import { z } from "zod";
import { VALIDATION_MESSAGES_CARD, noSpecialEmailCharsBeforeAt, emailRegex } from "constants/validations";

// Email Schema
export const emailSchema = z
    .string()
    .min(1, { message: VALIDATION_MESSAGES_CARD.FIELD_REQUIRED })
    .max(100, { message: "Maximum 100 characters" })
    .email({ message: "Invalid email format" })
    .refine((email) => !email.includes("@@"), { message: "Email cannot contain double @ characters" })
    .refine((email) => noSpecialEmailCharsBeforeAt.test(email), {
        message: 'Email cannot contain these characters before @: "(),:;<>[]&',
    })
    .refine((email) => emailRegex.test(email), { message: "Invalid email format" });

export const optionalEmailSchema = z.union([z.literal(""), emailSchema]).optional();
